import React from 'react';
import {
  createSiteChromeStaticContextProvider,
  Footer,
  Header,
  Navigation,
  SEOLinks,
  SiteChromeDynamicContextProvider,
} from '@noths/polaris-client-site-chrome-ui';
import cookies from 'js-cookie';

import type { SiteChromeLayoutComponentProps } from '../types';

const appSelector = '#NOTHSPageWrapper';
const SiteChromeStaticContextProvider = createSiteChromeStaticContextProvider(appSelector);

export const ClientSiteChromeUI = ({
  children,
  enableCurator = false,
  isProdLikeEnv,
  mergeBasket,
  searchedTerm,
  siteChromeCompactMode = false,
  siteChromeContent,
  stickyTopBanner = false,
}: SiteChromeLayoutComponentProps) => {
  const siteChromeEnv = isProdLikeEnv ? 'production' : 'qa';
  const { navContent, topBannerMessages } = siteChromeContent || {};

  return (
    <>
      {navContent && <SEOLinks content={navContent} />}
      <SiteChromeStaticContextProvider
        compact={siteChromeCompactMode}
        cookies={cookies}
        env={siteChromeEnv}
        mergeBasket={mergeBasket}
        searchedTerm={searchedTerm}
      >
        <SiteChromeDynamicContextProvider>
          <>
            <Header
              enableCurator={enableCurator}
              stickyTopBanner={stickyTopBanner}
              topBannerMessages={topBannerMessages || []}
            />
            {navContent && <Navigation content={navContent} />}
            <main role="main">{children}</main>
            <Footer />
          </>
        </SiteChromeDynamicContextProvider>
      </SiteChromeStaticContextProvider>
    </>
  );
};
